<template>
    <div class="animated fadeIn master-page">
        <div class="row">
            <!-- Left Card: Form Control Panel -->
            <div class="col-12 col-lg-4 mb-4 mb-lg-0">
                <div class="laporan-form-card h-100 d-flex flex-column justify-content-between">
                    <div>
                        <!-- Title -->
                        <h4 class="form-card-title mb-4">Pembayaran</h4>

                        <b-form @submit.prevent="openModalConfirm" id="formLaporanPembayaran">
                            <!-- Cabang -->
                            <b-form-group label="Cabang" label-class="form-input-label" class="mb-3">
                                <multiselect
                                    name="cabang"
                                    v-model="input.cabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih Cabang --"
                                    class="custom-multiselect"
                                />
                            </b-form-group>

                            <!-- Tipe Pinjaman -->
                            <b-form-group label="Tipe Pinjaman" label-class="form-input-label" class="mb-3">
                                <b-form-select 
                                    class="form-control-custom" 
                                    v-model="input.tipe" 
                                    name="tipe" 
                                    :options="tipeOption" 
                                    value-field="id" 
                                    text-field="name"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Tipe Pinjaman --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>

                            <!-- Metode Pembayaran -->
                            <b-form-group label="Metode Pembayaran" label-class="form-input-label" class="mb-3">
                                <b-form-select 
                                    class="form-control-custom" 
                                    v-model="input.metodePembayaran" 
                                    name="metodePembayaran" 
                                    :options="optionPembayaran" 
                                    value-field="id" 
                                    text-field="name"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Metode --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>

                            <!-- Periode Section -->
                            <div class="periode-section mb-4">
                                <!-- Harian -->
                                <div class="periode-row d-flex align-items-center mb-3">
                                    <div class="radio-label-wrapper">
                                        <b-form-radio v-model="dateType" value="harian" class="custom-radio">
                                            <span class="radio-text">Harian</span>
                                        </b-form-radio>
                                    </div>
                                    <div class="flex-grow-1 pl-2">
                                        <b-form-input 
                                            v-model="input.tanggal" 
                                            name="tanggal" 
                                            type="date" 
                                            :min="minDate" 
                                            :max="maxDate"
                                            class="form-control-custom"
                                            :class="{ 'active-input': dateType === 'harian' }"
                                            :disabled="dateType !== 'harian'"
                                        ></b-form-input>
                                    </div>
                                </div>

                                <!-- Bulanan -->
                                <div class="periode-row d-flex align-items-center">
                                    <div class="radio-label-wrapper">
                                        <b-form-radio v-model="dateType" value="bulanan" class="custom-radio">
                                            <span class="radio-text">Bulanan</span>
                                        </b-form-radio>
                                    </div>
                                    <div class="flex-grow-1 pl-2">
                                        <!-- Non Full Access -->
                                        <b-form-select 
                                            v-if="fullAccess != 1"
                                            v-model="input.bulan" 
                                            id="inputBulan" 
                                            name="inputBulan" 
                                            :options="optionBulan" 
                                            value-field="id" 
                                            text-field="name"
                                            class="form-control-custom w-100"
                                            :class="{ 'active-input': dateType === 'bulanan' }"
                                            :disabled="dateType !== 'bulanan'"
                                        >
                                            <template v-slot:first>
                                                <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                            </template>
                                        </b-form-select>

                                        <!-- Full Access -->
                                        <div v-else class="d-flex gap-2">
                                            <b-form-select 
                                                class="form-control-custom mr-2" 
                                                v-model="input.bulan" 
                                                id="inputBulan" 
                                                name="inputBulan" 
                                                :options="bulan" 
                                                value-field="id" 
                                                text-field="name"
                                                :class="{ 'active-input': dateType === 'bulanan' }"
                                                :disabled="dateType !== 'bulanan'"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <b-form-select 
                                                class="form-control-custom" 
                                                v-model="input.tahun" 
                                                id="inputTahun" 
                                                name="inputTahun" 
                                                :options="optionTahun"
                                                :class="{ 'active-input': dateType === 'bulanan' }"
                                                :disabled="dateType !== 'bulanan'"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Cetak Button -->
                            <button 
                                type="submit" 
                                name="submitLaporan" 
                                class="btn btn-cetak-full w-100"
                                :disabled="isSubmitting"
                            >
                                <b-spinner small type="grow" v-if="isSubmitting" class="mr-2"></b-spinner>
                                <span>{{ isSubmitting ? 'Memproses...' : 'Cetak' }}</span>
                            </button>
                        </b-form>
                    </div>

                    <!-- Footnote -->
                    <div class="form-footnote mt-4">
                        <p class="mb-0">
                            Bila laporan tidak muncul setelah lebih dari 30 detik, 
                            <a v-if="urlLaporan" :href="urlLaporan" target="_blank" class="footnote-link">buka link laporan langsung</a>
                            <span v-else>buka link laporan langsung</span> 
                            atau hubungi HO.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Right Card: Report Preview Panel -->
            <div class="col-12 col-lg-8">
                <div class="laporan-preview-card h-100 d-flex flex-column">
                    <!-- Preview Header -->
                    <div class="preview-header d-flex flex-wrap align-items-center justify-content-between mb-3">
                        <h4 class="preview-title mb-0">Pratinjau Laporan</h4>
                        <div class="preview-actions d-flex align-items-center">
                            <a 
                                :href="urlLaporan || '#'" 
                                download
                                class="btn btn-outline-action mr-2"
                                :class="{ 'disabled': !urlLaporan }"
                                @click="!urlLaporan ? $event.preventDefault() : null"
                            >
                                Unduh PDF
                            </a>
                            <a 
                                :href="urlLaporan || '#'" 
                                target="_blank" 
                                class="btn btn-outline-action"
                                :class="{ 'disabled': !urlLaporan }"
                                @click="!urlLaporan ? $event.preventDefault() : null"
                            >
                                Buka di tab baru
                            </a>
                        </div>
                    </div>

                    <!-- Preview Frame / Placeholder Box -->
                    <div class="preview-frame-container flex-grow-1">
                        <div v-if="urlLaporan" class="iframe-inner h-100">
                            <iframe 
                                width="100%" 
                                height="100%" 
                                :src="urlLaporan" 
                                frameborder="0" 
                                allowfullscreen
                                class="report-iframe"
                            ></iframe>
                        </div>
                        <div v-else class="empty-placeholder d-flex align-items-center justify-content-center h-100">
                            <div class="placeholder-tag">
                                <span>iframe laporan - urlLaporan</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Confirm -->
        <ModalConfirm 
            id="modal-confirm-cetak" 
            title="Konfirmasi Cetak Laporan Pembayaran" 
            :isSubmitting="isSubmitting" 
            desc="Apakah anda yakin untuk mencetak laporan pembayaran ini?" 
            @submit="onSubmit" 
        />
    </div>
</template>

<script>
export default {
    name: 'laporan-pembayaran',
    data(){
        return{
            isSubmitting: false,
            cabang: null,
            fullAccess: null,
            input: {
                cabang: null,
                tipe: null,
                tanggal: null,
                bulan: null,
                tahun: null,
                metodePembayaran: null
            },
            cabangOption: [],
            optionBulan: [],
            optionTahun: [],
            tipeOption: [],
            bulan: [
                { id: "1", name: "Januari" },
                { id: "2", name: "Februari" },
                { id: "3", name: "Maret" },
                { id: "4", name: "April" },
                { id: "5", name: "Mei" },
                { id: "6", name: "Juni" },
                { id: "7", name: "Juli" },
                { id: "8", name: "Agustus" },
                { id: "9", name: "September" },
                { id: "10", name: "Oktober" },
                { id: "11", name: "November" },
                { id: "12", name: "Desember" }
            ],
            optionPembayaran: [
                { id: true, name: "Tunai" },
                { id: false, name: "Non-Tunai" }
            ],
            dateType: "harian",
            urlLaporan: null,
            minDate: null,
            maxDate: null
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.cabangOption = this.$helper.getAllCabang()

            // Tipe pinjaman mengikuti master (jenis_pinjaman), bukan daftar tetap
            this.$axios.get('tipe-pinjaman/selection').then(response => {
                this.tipeOption = response.data
            })

            this.$axios.get('laporan/durasi-laporan').then(response => {
                this.fullAccess = response.data.id
                
                let date = new Date().toISOString().slice(0,10)
                this.input.tanggal = date
                
                // Harian

                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1; //January is 0!
                var yyyy = today.getFullYear();
                if(dd<10){
                    dd='0'+dd
                } 
                if(mm<10){
                    mm='0'+mm
                } 

                today = yyyy+'-'+mm+'-'+dd;
                this.maxDate = today

                if (this.fullAccess != 1){
                    var threeDaysAgo = new Date()
                    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
                    var dd = threeDaysAgo.getDate()
                    var mm = threeDaysAgo.getMonth()+1
                    var yyyy = threeDaysAgo.getFullYear()
                    if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                    threeDaysAgo = yyyy+'-'+mm+'-'+dd;
                    this.minDate = threeDaysAgo
                }

                // Bulanan

                var months = ["Januari", "Februari", "Maret", "April", 
                                "Mei", "Juni", "Juli", "Agustus", 
                                "September", "Oktober", "November", "Desember"]
                
                if (this.fullAccess != 1){
                    var d = new Date()
                    var thisMonth = d.getMonth()
                    var thisYear = d.getFullYear()

                    var lastMonth = d.getMonth() - 1
                    if(lastMonth < 0){
                        lastMonth += 12
                        d.setYear(d.getYear() - 1)
                        var lastYear = d.getFullYear()
                    } else {
                        var lastYear = thisYear
                    }

                    this.optionBulan = [
                        { id: thisMonth+"-"+thisYear, name:months[thisMonth]+" "+thisYear },
                        { id: lastMonth+"-"+lastYear, name:months[lastMonth]+" "+lastYear }
                    ]
                } else {
					var thisYear = new Date().getFullYear()
                    for(var i = 2019; i <= thisYear; i++) {
                        this.optionTahun.push(i)
                    }
                }
            })
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            this.isSubmitting = true

            let requestUrl = ""
            if (this.dateType == 'harian'){
                requestUrl = "laporan/pembayaran?cabangId="+this.input.cabang.id+"&startDate="+this.input.tanggal
                                +"&endDate="+this.input.tanggal+"&tipePinjaman="+this.input.tipe+"&tunai="+this.input.metodePembayaran
            } else {
                requestUrl = "laporan/pembayaran?cabangId="+this.input.cabang.id+"&month="+this.input.bulan
                                +"&year="+this.input.tahun+"&tipePinjaman="+this.input.tipe+"&tunai="+this.input.metodePembayaran
            }

            this.$axios.get(requestUrl).then(response => {
                let filePath = response.data
                if (typeof filePath === 'object' && filePath !== null && filePath.name) {
                    filePath = filePath.name
                }
                let base = this.$baseFilePath.endsWith('/') ? this.$baseFilePath : this.$baseFilePath + '/'
                let path = filePath.startsWith('/') ? filePath.slice(1) : filePath
                this.urlLaporan = base + path

                this.$helper.setFlash(`Laporan pembayaran berhasil dibuat!`)
                this.$bvModal.hide("modal-confirm-cetak")
                
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })
            .catch(error => {
                console.log(error)
                if (error.response && error.response.data && error.response.data.reason) {
                    console.log(error.response.data.reason)
                }
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (this.input.cabang == null || this.input.tipe == null || this.input.metodePembayaran == null || 
                    this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.tanggal) || 
                    this.dateType == 'bulanan' && this.input.bulan == null ||
                    this.dateType == 'bulanan' && this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon lengkapi data untuk cetak laporan!")
            } else {
                this.$bvModal.show("modal-confirm-cetak")
            }            
        }
    },

    created(){
        this.init()
    }
}
</script>

<style lang="scss" scoped>
$deep-pine: #023831;
$deep-pine-hover: #034d43;
$gold-accent: #C69B6B;
$ink-heading: #1B2E28;
$ink-body: #32433D;
$ink-muted: #8C9F98;
$input-border: #D8E0DC;
$card-border: #E8ECE9;

.master-page {
    padding: 0 4px 24px;
}

// Left Card
.laporan-form-card {
    background: #FFFFFF;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(2, 56, 49, 0.05);
    border: 1px solid $card-border;
    padding: 24px 26px;
}

.form-card-title {
    font-size: 18px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

::v-deep .form-input-label {
    font-size: 13px;
    font-weight: 500;
    color: $ink-body;
    margin-bottom: 6px;
}

.form-control-custom {
    height: 38px;
    border-radius: 8px;
    border: 1px solid $input-border;
    font-size: 13px;
    color: $ink-body;
    padding: 6px 12px;
    background-color: #FFFFFF;
    transition: all 0.2s ease;

    &:focus {
        border-color: $deep-pine;
        box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
        outline: none;
    }

    &.active-input {
        border-color: $deep-pine;
    }

    &:disabled {
        background-color: #F8FAF9;
        opacity: 0.65;
        cursor: not-allowed;
    }
}

// Radio Section
.periode-section {
    .radio-label-wrapper {
        min-width: 85px;
    }

    .radio-text {
        font-size: 13px;
        font-weight: 500;
        color: $ink-body;
    }
}

// Multiselect styling
.custom-multiselect {
    min-height: 38px;

    ::v-deep {
        .multiselect__tags {
            min-height: 38px;
            border-radius: 8px;
            border: 1px solid $input-border;
            padding: 7px 36px 0 12px;
            background: #FFFFFF;
            transition: all 0.2s ease;
        }

        .multiselect__placeholder {
            margin-bottom: 0;
            padding-top: 0;
            color: #8C9F98;
            font-size: 13px;
        }

        .multiselect__single {
            margin-bottom: 0;
            padding-top: 0;
            font-size: 13px;
            color: $ink-body;
            line-height: 22px;
        }

        .multiselect__select {
            height: 36px;
            width: 32px;
            padding: 4px 6px;
        }

        &.multiselect--active .multiselect__tags {
            border-color: $deep-pine;
            box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
        }
    }
}

// Button Cetak
.btn-cetak-full {
    background-color: $deep-pine;
    border: none;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    height: 42px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background-color: $deep-pine-hover;
        color: #FFFFFF;
        box-shadow: 0 4px 10px rgba(2, 56, 49, 0.15);
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
}

.form-footnote {
    font-size: 11.5px;
    color: #8C9F98;
    line-height: 1.45;

    .footnote-link {
        color: $deep-pine;
        font-weight: 500;
        text-decoration: underline;

        &:hover {
            color: $deep-pine-hover;
        }
    }
}

// Right Card (Preview)
.laporan-preview-card {
    background: #FFFFFF;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(2, 56, 49, 0.05);
    border: 1px solid $card-border;
    padding: 24px 26px;
    min-height: 560px;
}

.preview-title {
    font-size: 18px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

.btn-outline-action {
    background: #FFFFFF;
    border: 1px solid #BAC9C2;
    color: #4B605A;
    font-size: 12px;
    font-weight: 500;
    padding: 6px 14px;
    border-radius: 6px;
    text-decoration: none;
    transition: all 0.2s ease;

    &:hover:not(.disabled) {
        background: #F4F7F5;
        border-color: #8C9F98;
        color: #1B2E28;
        text-decoration: none;
    }

    &.disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }
}

.preview-frame-container {
    border: 1.5px dashed #D2DDD7;
    border-radius: 12px;
    min-height: 480px;
    overflow: hidden;
    position: relative;
}

.report-iframe {
    border-radius: 10px;
    border: none;
    background: #525659;
}

.empty-placeholder {
    background: repeating-linear-gradient(
        135deg,
        #F9FBFA,
        #F9FBFA 14px,
        #F1F5F3 14px,
        #F1F5F3 28px
    );

    .placeholder-tag {
        background: #FFFFFF;
        border: 1px solid #D8E0DC;
        padding: 8px 18px;
        border-radius: 8px;
        color: #2F4F46;
        font-family: monospace;
        font-size: 12.5px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    }
}

// Custom Radio Indicator
::v-deep .custom-radio {
    .custom-control-input:checked ~ .custom-control-label::before {
        background-color: $deep-pine;
        border-color: $deep-pine;
    }
}
</style>
